import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { LCardSinistro } from "../styled/Containers.style"
import { LCardLabel, LCardRow, LCardTitle, LCardValue } from "../styled/Text.style"

const SinistroCardLinear = () => {

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData

    return <LCardSinistro>
        <LCardTitle><strong>Dati sinistro</strong></LCardTitle>
        <LCardRow>
            <LCardLabel>Data del sinistro:</LCardLabel>
            <LCardValue>{communication?.inc_data}</LCardValue>
        </LCardRow>
        <LCardRow>
            <LCardLabel>Targa del tuo veicolo:</LCardLabel>
            <LCardValue>{communication?.veic_targa}</LCardValue>
        </LCardRow>
        <LCardRow>
            <LCardLabel>N° del sinistro:</LCardLabel>
            <LCardValue>{communication?.caiData?.claimNumber}</LCardValue>
        </LCardRow>
    </LCardSinistro>

}

export default SinistroCardLinear